module.exports = __webpack_public_path__ + "static/media/skyNemo.ef58cfa7.jpg";